module.exports = __webpack_public_path__ + "img/3.f3c829d1.jpg";